module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./NewAddView.js"));
	}, "NewAddView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NewAddView!./src/pages/Promote/Schedule/NewAdd/NewAddView.js
// module id = 2094
// module chunks = 367